import { FC, SVGProps } from 'react'

interface ArrowDownIconProps extends SVGProps<SVGSVGElement> {
  size?: number
}

export const ArrowDownIcon: FC<ArrowDownIconProps> = ({
  size = 20,
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 5L7 9L11 5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
